module.exports = __webpack_public_path__ + "static/media/american-express.38de1a06.svg";